import { useContext } from 'react';
import { AccountContext } from '../components/AccountContext';

export const useAccountFullConfigData = () => {
    const { accountConfig } = useContext(AccountContext);

    return accountConfig;
};
